import axios from 'axios';

import consts from '../consts';
import { setErroAPI } from '../common/toast/toast';

export const DRE_AGUARDANDO = 'DRE_AGUARDANDO';
export const DRE_CARREGADO = 'DRE_CARREGADO';

export function getDRE(filtros) {
    return async dispatch => {
        try {
            dispatch({
                type: DRE_AGUARDANDO,
                payload: true
            });

            const resposta = await axios.get(
                `${consts.API_URL}/dre`,
                {
                    params: {
                        data_inicial: filtros.dataInicial,
                        data_final: filtros.dataFinal,
                        regime: filtros.regime
                    }
                }
            );

            dispatch({
                type: DRE_CARREGADO,
                payload: resposta.data
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch({
                type: DRE_AGUARDANDO,
                payload: false
            });
        }
    };
}
